module.exports = __webpack_public_path__ + "images/Icon_Advise.png?3c8cb80";


//////////////////
// WEBPACK FOOTER
// ./assets/component/index/images/icons/Icon_Advise.png
// module id = 339
// module chunks = 0